import { createContext, useContext, useEffect } from "react";

/** F-227: opening a page-replacing drawer dismisses an alongside-page panel. */
export const DrawerOpenContext = createContext<(() => () => void) | null>(null);

export function useDrawerOpen(open: boolean) {
  const onDrawerOpen = useContext(DrawerOpenContext);
  useEffect(() => {
    if (open) return onDrawerOpen?.();
    return undefined;
  }, [onDrawerOpen, open]);
}
